import * as api from "../Api";

export const getLocations = () => async (dispatch) => {
  try {
    const { data } = await api.locations();
    dispatch({ type: "GET_LOCATIONS", payload: data });
  } catch (error) {}
};
